const pl = {
  "": {
    "loading": "Trwa ładowanie. Jeszcze chwilka!",
    "NotFoundScreenError": "Strona nie istnieje",
    "GoBack": "Wróć",
    "company-info-short": "Info",
    "company-info": "Dane firmy",
    "opening-hours": "Godziny otwarcia",
  },
  "form": {
    "required-field": "Pole wymagane",
    "enter-full-name": "Podaj swoje imię i nazwisko",
    "enter-email": "Podaj adres email",
    "required-choose": "Wybierz",
    "accept-rules": "Zaakceptuj regulamin",
    "choose": "Wybierz...",
  },
  "payment": {
    "blik-format-error": "Kod BLIK powinien składać się z 6 cyfr",
    "blik-enter": "Podaj kod BLIK",
    "choose-payment-method": "Wybierz sposób płatności",
    "label": {
      "full-name": "Twoje imię i nazwisko",
      "confirmation-email": "Wyślij potwierdzenie na",
      "payment-method": "Wybierz metodę płatności",
      "payment-method-with": "Wybierz metodę płatności z ",
    },
    "transfer": "Przelew Online",
    "pay": "Zapłać",
    "pay-now": "Zapłać\nteraz",
    "pay-on-site": "Zapłać\nna miejscu",
    "paid": "Opłacone",
    "payment-error": "Płatność nie powiodła się",
    "waiting-for-payment": "Trwa przetwarzanie płatności...",
    "waiting-for-blik-payment":
      "Potwierdź transakcję BLIK w aplikacji mobilnej banku.",
    "go-to-payment": "Przejdź do strony płatności",
    "tpay-rules":
      "Akceptuję <rules>regulamin</rules> serwisu Tpay.<br/> Administratorem danych osobowych jest Krajowy Integrator Płatności spółka akcyjna z siedzibą w Poznaniu. <full>Zapoznaj się z pełną treścią.</full>",
    "waiting-too-long":
      "Przepraszamy, że trwa to tak długo ale nie dostaliśmy informacji o płatności od Twojego banku. Może oznaczać to iż przerwałeś płatność albo coś poszło nie tak. Wybierz jedną z opcji poniżej aby dokończyć zamówienie:<br/> <redirect>Kontynuuj płatność</redirect> <br/> lub <retry>rozpocznij płatność od początku</retry>",
    "retry-payment": "Powtórz płatność",
  },
  "footer": {
    "operated-by": "Obsługiwane przez ",
    "payments-by": "Płatności przez ",
    "terms": "Regulaminy",
  },
};

const en = {
  "": {
    "loading": "Loading. Please wait...",
    "NotFoundScreenError": "The page is not found",
    "GoBack": "Go back",
    "company-info-short": "Info",
    "company-info": "Company info",
    "opening-hours": "Opening hours",
  },
  "form": {
    "required-field": "Required field",
    "enter-full-name": "Enter your full name",
    "enter-email": "Enter your email address",
    "required-choose": "Choose",
    "accept-rules": "Accept rules",
    "choose": "Choose...",
  },
  "payment": {
    "blik-format-error": "BLIK code should contain 6 digits",
    "blik-enter": "Enter BLIK code",
    "choose-payment-method": "Choose payment method",
    "label": {
      "full-name": "Your full name",
      "confirmation-email": "Send payment confirmation to",
      "payment-method": "Payment method",
      "payment-method-with": "Payment method with ",
    },
    "transfer": "Transfer",
    "pay": "Pay",
    "pay-now": "Pay\nnow",
    "pay-on-site": "Pay\non site",
    "paid": "Paid",
    "payment-error": "Payment has failed",
    "waiting-for-payment": "Processing payment...",
    "waiting-for-blik-payment": "Confirm your BLIK payment.",
    "go-to-payment": "Go to the payment page",
    "tpay-rules":
      "I accept <rules>the Terms</rules> of Tpay service.<br/> Administratorem danych osobowych jest Krajowy Integrator Płatności spółka akcyjna z siedzibą w Poznaniu. <full>Zapoznaj się z pełną treścią.</full>",
    "waiting-too-long":
      "If you have interrupted the payment process,<br/> <redirect>Resume payment</redirect> <br/> or <retry>here to start a new payment</retry>.",
    "retry-payment": "Retry payment",
  },
  "footer": {
    "operated-by": "Operated by ",
    "payments-by": "Payments by ",
    "terms": "Terms and conditions",
  },
};

export const resources = { "pl": pl, "en": en };
